import { inject, Injectable } from '@angular/core';
import { PipelineStageSelectorService } from '@features/audience/pipelines/services/pipeline-stage-selector.service';
import { CampaignsService } from '@features/campaigns/campaigns.service';
import { BillingService } from '@features/settings/billing/services/billing.service';
import { SocialListeningService } from '@features/social-analysis/social-listening/social-listening.service';
import { SocialUsersService } from '@features/social-analysis/social-users/social-users.service';
import { AccountService } from './admin/account.service';
import { AdminService } from './admin/admin.service';
import { EcommerceAccountService } from './admin/ecommerce-account.service';
import { InstagramService } from './admin/instagram.service';
import { LoggedUserService } from './admin/logged-user.service';
import { MailboxService } from './admin/mailbox.service';
import { AiAgentsGlobalService } from './store/ai-agents-global.service';
import { DepartmentsGlobalService } from './store/departments-global.service';
import { UsersGlobalService } from './store/users-global.service';

@Injectable({
    providedIn: 'root',
})
export class ResetAppStateService {
    private readonly accountS = inject(AccountService);
    private readonly ecommerceS = inject(EcommerceAccountService);
    private readonly instagramS = inject(InstagramService);
    private readonly userS = inject(LoggedUserService);
    private readonly adminS = inject(AdminService);
    private readonly socListenS = inject(SocialListeningService);
    private readonly socUsersS = inject(SocialUsersService);
    private readonly campaignsS = inject(CampaignsService);
    private readonly billingS = inject(BillingService);
    private readonly departmentsS = inject(DepartmentsGlobalService);
    private readonly aiAgentsS = inject(AiAgentsGlobalService);
    private readonly usersS = inject(UsersGlobalService);
    private readonly pipelinesS = inject(PipelineStageSelectorService);
    private readonly mailboxS = inject(MailboxService);

    resetAppState() {
        this.socListenS.resetState();
        this.socUsersS.resetState();
        this.adminS.resetState();
        this.userS.resetState();
        this.departmentsS.resetState();
        this.aiAgentsS.resetState();
        this.usersS.resetState();
        this.pipelinesS.resetState();
        this.accountS.resetState();
        this.ecommerceS.resetState();
        this.instagramS.resetState();
        this.campaignsS.resetState();
        this.billingS.resetState();
        this.mailboxS.resetState();
    }
}
